import React, {useState, useEffect, useMemo, useRef} from "react";
import GenericTemplate from "../../templates/GenericTemplate";
import {apollo_useStyles, options_matchtype, valueToOption} from "../../atom/Apollo_styles";
import {APOLLO_SYSTEM_ADMIN, APOLLO_GROUP_OPERATOR, ApolloPageUsagePermission} from "../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";

import {useForm, Controller} from "react-hook-form";
import {Link, useHistory} from "react-router-dom";

import {MeasureConditions} from "./HeraMeasureConditionEdit";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField/TextField";
import InputAdornment from '@material-ui/core/InputAdornment';
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";

import Button from "@material-ui/core/Button";

import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";

import {ApolloContext} from "../../atom/Apollo_Context";
import axios from "axios";
import moment from "moment";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";

import {
  Event,
  AudienceCreateRequest,
} from "./HeraModel"

import {hera_events_path, hera_audiences_path} from "../../atom/Apollo_links"

import {ApolloEventRecord, ItemList} from "../../atom/Apollo_EventRecord";
import {checkInvalidCharForName} from "../../common/Apollo_CommonUtil";

// エラーメッセージ
const ERROR_MESSAGE = [
  "データの取得に失敗しました",
  "オーディエンス新規登録に失敗しました",
];
// 警告メッセージ
const WARNING_MESSAGE = [
  "有効なオーディエンスの上限数を超えてしまうため、作成することができませんでした。他の有効なオーディエンスのステータスを「無効」にしてから、再度作成してください。",
]

const animatedComponents = makeAnimated();

/*
    画面名：：
 */
const HeraAudienceEdit: React.FC = () => {
  const classes = apollo_useStyles();
  let history = useHistory();

  const handelGoback = () => {
    history.goBack();
  };

  const {state} = React.useContext(ApolloContext);

  const trackerId = state.current.trackerId

  const [conditionIndexes, setConditionIndexes] = useState<number[]>([]);
  const [events, setEvents] = useState<Event[]>([]);

  const {data, setmsg} = React.useContext(ApolloMessage);

  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    })
    const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_events_path}/${trackerId}`
    axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${state.accesstoken}`,
      }
    }).then((response) => {
      if (response.data.resultcode === 0) {
        setEvents(response.data.result);
      } else {
        console.log(response.data.message);
        const errMsg = response.data.message ? response.data.message : ERROR_MESSAGE[0];
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMsg
          }
        });
      }
    })
      .catch(err => {
        const errMsg = err.message ? err.message : ERROR_MESSAGE[0];
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMsg
          }
        });
      })
      .finally(() => {
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
      })
  }, [])

  const options_event = events?.map(event => ({value: event.ID, label: event.name}))

  const addConditions = (index: number[]) => () => {
    if (index.length < 10) {
      setConditionIndexes(current => [...current, current.length > 0 ? Math.max(...current) + 1 : current.length]);
    }
};
  const removeConditions = (index: number) => () => {
    setConditionIndexes(current => [...current.filter(i => i !== index)]);
  };

  const formHooks = useForm({
    mode: "onBlur",
    reValidateMode: "onBlur",
  });
  const { register, handleSubmit, control, errors, formState, watch } = formHooks;

  // 必須項目を監視して、canSubmitをリアルタイムで更新
  const watched = watch(["name", "audienceSpan", "EventID", "urlPatterns"]);

  // 必須項目の入力値を確認し、送信可能か判断する
  const canSubmit = useMemo(() => {
    if (formState.isSubmitting || processing) return false;
    if (!formState.isValid) return false;

    const { name, audienceSpan, EventID, urlPatterns } = watched;

    if (!name || name.trim() === "") return false;

    const span = Number(audienceSpan);
    if (!Number.isFinite(span) || span < 0 || span > 90) return false;

    if (!EventID?.value) return false;

    if (conditionIndexes.length === 0) return true;

    const patterns = urlPatterns ?? [];
    for (const idx of conditionIndexes) {
      const row = patterns[idx];
      if (!row?.pattern || row.pattern.trim() === "") return false;
      if (!row?.matchType?.value) return false;
    }
    return true;
  }, [watched, conditionIndexes, formState.isSubmitting, processing]);


  const onSubmit = handleSubmit(async (formData: any) => {
    if (formState.isSubmitting) return;
    if (processing) return;
    let isSuccess = false;
    let targetID = "";
    let targetName = "";

    const urlPatterns = formData.urlPatterns?.filter((pattern: any, index: number) => conditionIndexes.includes(index))
    const audienceCreateRequest: AudienceCreateRequest = {
      name: formData.name,
      condition: {
        eventID: formData.EventID.value,
        urlTarget: conditionIndexes.length > 0 ? true : false,
        urlPatterns: urlPatterns?.map((urlPattern: any) => (
          {
            pattern: urlPattern.pattern,
            matchType: urlPattern.matchType.value
          }
        )),
      },
      audienceSpan: parseInt(formData.audienceSpan),
    }

    if (conditionIndexes.length > 10) {
      return setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "MeasureConditionは10個が上限です"
        }
      });
    }

    const urlPatternAfterVal = audienceCreateRequest.condition.urlPatterns?.map((urlPattern: any) => (
      {
        "URLパターン": valueToOption(urlPattern.matchType, options_matchtype).label,
        "URL": urlPattern.pattern,
      }
    ))

    let itemList: ItemList[] = [
      {
        key: "オーディエンス名",
        beforeValue: "",
        afterValue: audienceCreateRequest.name,
      },
      {
        key: "有効期限",
        beforeValue: "",
        afterValue: audienceCreateRequest.audienceSpan.toString(),
      },
      {
        key: "イベント名",
        beforeValue: "",
        afterValue: valueToOption(audienceCreateRequest.condition.eventID, options_event).label,
      },
      {
        key: "URLパターン",
        beforeValue: "",
        afterValue: JSON.stringify(urlPatternAfterVal),
      },
    ]
    // 実行時
    ApolloEventRecord({
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: "execute",
      result: "",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken ,
      accountGroupID : state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID : state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "",
      displayName: "オーディエンス新規登録画面",
      category: "オーディエンス",
      actionType: "作成",
      targetID: "",
      targetName: "",
      itemList: itemList,
    });

    setProcessing(true);
    const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_audiences_path}/${trackerId}`
    await axios.post(
      url,
      audienceCreateRequest,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${state.accesstoken}`,
        }
      })
      .then((response) => {
        if (response.data.resultcode === 0) {
          isSuccess = true;
          if (response.data.result) {
            targetID = response.data.result[0].ID;
            targetName = audienceCreateRequest.name;
          }
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "success",
              message: "オーディエンス新規登録に成功しました"
            }
          });
        } else {
          console.log(response.data.message);
          const type: string = response?.data?.message === "有効可能上限数エラー" ? "warning" : "error"
          const message: string = response?.data?.message === "有効可能上限数エラー" ? WARNING_MESSAGE[0] : response?.data?.message ?? ERROR_MESSAGE[1]
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: type,
              message: message
            }
          });
        }
      })
      .catch(err => {
        const errMsg = err.message ? err.message : ERROR_MESSAGE[1];
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMsg
          }
        });
      })
      .finally(() => {
        // 実行結果
        ApolloEventRecord({
          eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
          logType: "result",
          result: isSuccess? "成功" : "失敗",
          userID: state.userprofile.userId,
          userName: state.userprofile.userName,
          accessToken: state.accesstoken ,
          accountGroupID : state.current.accountGroupId,
          accountGroupName: state.current.accountGroupName,
          accountID : state.current.accountId,
          accountName: state.current.accountName,
          campaignID: "", // キャンペーンID
          campaignName: "", // キャンペーン名
          adGroupID: "", // 広告グループID
          adGroupName: "", // 広告グループ名
          menu: "",
          displayName: "オーディエンス新規登録画面",
          category: "オーディエンス",
          actionType: "作成",
          targetID: targetID,
          targetName: targetName,
          itemList: itemList,
        });

        setProcessing(false);

        if (isSuccess) {
          history.goBack();
        }
      })

  });

  return (
    <GenericTemplate title="">
      <CustomizedSnackbars/>
      <ApolloPageUsagePermission role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
        <ApolloBreadcrumbs bread_no={52} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""}
                          platform={""}/>
        <form noValidate onSubmit={onSubmit}>
          <Card className={classes.root} square variant="outlined">
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="trackerid"
                    name="trackerid"
                    label="トラッカーID"
                    inputRef={register}
                    fullWidth
                    disabled
                    defaultValue={trackerId}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="name"
                    name="name"
                    required
                    inputRef={register({
                      required: "必須入力項目です。",
                      maxLength: {
                        value: 128,
                        message: "128文字以内で入力して下さい。"
                      },
                      validate: (e: string) => {
                        const errorMessage = checkInvalidCharForName(e)
                        if(errorMessage) {
                          return errorMessage
                        }},
                    })}
                    label="オーディエンス名"
                    fullWidth
                    autoComplete="オーディエンス名"
                    defaultValue=""
                    helperText={errors?.name?.message}
                    error={errors?.name ? true : false}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="audienceSpan"
                    name="audienceSpan"
                    inputRef={register({
                      required: "必須入力項目です。",
                      min: {
                        value: 0,
                        message: "有効期限は0日以上で指定して下さい。"
                      },
                      max: {
                        value: 90,
                        message: "有効期限は90日以下で指定して下さい。"
                      }
                    })}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">日</InputAdornment>,
                    }}
                    label="有効期限"
                    type="number"
                    // fullWidth
                    autoComplete="有効期限"
                    defaultValue={30}
                    helperText={errors?.audienceSpan ? errors?.audienceSpan?.message : "0日〜90日で指定"}
                    error={errors?.audienceSpan ? true : false}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    測定条件
                  </Typography>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                      イベント名
                    </Typography>
                    <Controller
                      id="EventID"
                      name="EventID"
                      as={Select}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      key={options_event && options_event.length > 0 ? "Loaded" : "Loading"}
                      defaultValue={options_event && options_event.length > 0 && options_event[0]}
                      options={options_event}
                      menuPlacement="top"
                      control={control}
                    />
                  </Grid>
                  <Grid item xs={12} style={{marginTop: "10px"}}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                      URLパターン
                    </Typography>
                    <MeasureConditions conditionIndexes={conditionIndexes}
                                      addConditions={addConditions}
                                      removeConditions={removeConditions}
                                      formHooks={formHooks}/>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
            <CardActions className={classes.cardaction}>
              <Button
                type="submit"
                color="primary"
                className={classes.button}
                variant="contained"
                disabled={!canSubmit}
              >
                登録
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handelGoback}
                className={classes.button}
                disabled={formState.isSubmitting || processing}
              >
                戻る
              </Button>
            </CardActions>
          </Card>
        </form>
      </ApolloPageUsagePermission>
    </GenericTemplate>
  );
};

export default HeraAudienceEdit;
